import { cloneDeep } from 'lodash';
import {
  BeneficialOwnerRole,
  BeneficialOwnerType,
  CompanyApplicantRelatedPartyType,
  NonPersonRelatedPartyRelationshipType,
  TrustApplicantRelatedPartyType,
} from '@lendi/core-constants';

import { COMPANY_TYPE, CompanyContactType, STATE, VISIT_CONTACT_TYPE } from '@funnels/constants';
import { RelatedParty } from '@funnels/types';

export const RELATED_PARTY_MOCK_DATA: RelatedParty[] = [
  {
    applicationId: 'application-1',
    id: 'relatedParty-3',
    clientId: 'relatedParty-3-client',
    assetId: 'asset-1',
    firstName: 'Tom',
    lastName: 'Smith',
    phone: '401323462',
    title: 'MR',
    type: VISIT_CONTACT_TYPE.Tenant,
  },
  {
    applicationId: 'application-1',
    id: 'relatedParty-1',
    clientId: 'relatedParty-1-client',
    firstName: 'Satoshi',
    lastName: 'Nakamoto',
    phone: '400123456',
    businessName: 'Decentralized Systems',
    address: {
      postcode: 'string',
      state: STATE.NSW,
      city: 'Sydney',
      country: 'Australia',
      formatted: '8 Fake Street, Miranda, NSW, Australia',
      standard: {
        streetName: 'Rickard Street',
        streetNumber: '20',
        streetType: 'Street',
        level: '7',
        unit: '10',
      },
    },
    title: 'Mr',
    type: COMPANY_TYPE.Accountant,
    employmentId: 'employment-1',
  },
  {
    applicationId: 'application-1',
    id: 'relatedParty-2',
    clientId: 'relatedParty-2-client',
    firstName: 'Jack',
    lastName: 'Cage',
    phone: '400123346',
    businessName: 'Decentralized Systems',
    address: {
      postcode: 'string',
      state: STATE.VIC,
      city: 'Sydney',
      country: 'Australia',
      formatted: '8 Fake Street, Miranda, VIC, Australia',
      standard: {
        streetName: 'Rickard Street',
        streetNumber: '20',
        streetType: 'Street',
        level: '7',
        unit: '10',
      },
    },
    title: 'Mrs',
    type: COMPANY_TYPE.Solicitor,
    email: 'JackCage@gmail.com',
  },
  {
    id: 'relatedParty-licensedBuilder',
    applicationId: 'application-1',
    clientId: 'relatedParty-licensedBuilder-client',
    assetId: 'asset-1',
    type: COMPANY_TYPE.LicensedBuilder,
    businessName: 'Bob Construction PTY LTD',
    title: 'MR',
    firstName: 'Bob',
    lastName: 'The builder',
    phone: '+61400123456',
    licensedBuilderLandline: '+61412345567',
    address: {
      postcode: '2200',
      state: STATE.NSW,
      city: 'Sydney',
      country: 'Australia',
      formatted: '37 Pitt Street North, Sydney, NSW 2000, Australia',
      standard: {
        streetName: 'Pitt',
        streetNumber: '37',
        streetSuffix: 'North',
        streetType: 'Street',
        level: '9',
        unit: '101',
      },
    },
    licenseNumber: '84983S',
  },
  {
    id: 'relatedParty-4',
    clientId: 'relatedParty-4-client',
    type: TrustApplicantRelatedPartyType.Trustee,
    trustApplicantId: 'applicant-10',
    applicantId: 'applicant-1',
    trustApplicantClientId: 'applicant-10',
    applicantClientId: 'applicant-1',
  },
  {
    id: 'relatedParty-5',
    clientId: 'relatedParty-5',
    type: TrustApplicantRelatedPartyType.TrustBeneficialOwner,
    trustApplicantId: 'applicant-10',
    applicantId: 'applicant-1',
    trustApplicantClientId: 'applicant-10',
    applicantClientId: 'applicant-1',
    ownerRole: BeneficialOwnerRole.Accountant,
    ownerType: BeneficialOwnerType.Controller,
  },
  {
    id: 'relatedParty-5',
    clientId: 'relatedParty-5',
    type: TrustApplicantRelatedPartyType.TrustBeneficiary,
    trustApplicantId: 'applicant-10',
    applicantId: 'applicant-1',
    trustApplicantClientId: 'applicant-10',
    applicantClientId: 'applicant-1',
    distributionPercentage: 0.2,
  },
  {
    id: 'relatedParty-6',
    clientId: 'relatedParty-6',
    type: CompanyApplicantRelatedPartyType.Director,
    companyApplicantId: 'applicant-11',
    applicantId: 'applicant-1',
    companyApplicantClientId: 'applicant-11',
    applicantClientId: 'applicant-1',
  },
  {
    id: 'relatedParty-7',
    clientId: 'relatedParty-7',
    type: CompanyApplicantRelatedPartyType.CompanyBeneficialOwner,
    companyApplicantId: 'applicant-11',
    companyApplicantClientId: 'applicant-11',
    applicantClientId: 'applicant-1',
    applicantId: 'applicant-1',
    ownerRole: BeneficialOwnerRole.Ceo,
    ownerType: BeneficialOwnerType.Controller,
    ownerPercentage: 0.3,
  },
  {
    id: 'relatedParty-8',
    clientId: 'relatedParty-8',
    type: CompanyApplicantRelatedPartyType.Director,
    companyApplicantId: 'applicant-11',
    applicantId: 'applicant-2',
    companyApplicantClientId: 'applicant-11',
    applicantClientId: 'applicant-2',
  },
  {
    id: 'relatedParty-9',
    clientId: 'relatedParty-9',
    type: CompanyApplicantRelatedPartyType.CompanyBeneficialOwner,
    companyApplicantId: 'applicant-11',
    applicantId: 'applicant-2',
    companyApplicantClientId: 'applicant-11',
    applicantClientId: 'applicant-2',
    description: 'description',
    ownerType: BeneficialOwnerType.Other,
    ownerPercentage: 0.45,
  },
  {
    id: 'relatedParty-10',
    clientId: 'relatedParty-10',
    type: TrustApplicantRelatedPartyType.Trustee,
    trustApplicantId: 'applicant-10',
    applicantId: 'applicant-11',
    trustApplicantClientId: 'applicant-10',
    applicantClientId: 'applicant-11',
  },
  {
    id: 'relatedParty-11',
    clientId: 'relatedParty-11',
    type: CompanyApplicantRelatedPartyType.CompanyContact,
    companyApplicantId: 'applicant-11',
    companyContactType: CompanyContactType.NonApplicant,
    title: 'Dr',
    firstName: 'CompanyContactFirstName',
    lastName: 'CompanyContactLastName',
    registeredAddress: {
      postcode: '2200',
      state: STATE.NSW,
      city: 'Sydney',
      country: 'Australia',
      formatted: '37 Pitt Street North, Sydney, NSW 2000, Australia',
      standard: {
        streetName: 'Pitt',
        streetNumber: '37',
        streetSuffix: 'North',
        streetType: 'Street',
        level: '9',
        unit: '101',
      },
    },
    contactNumber: '+61400123456',
  },
  {
    id: 'relatedParty-12',
    clientId: 'relatedParty-12',
    type: TrustApplicantRelatedPartyType.TrustSettlor,
    trustSettlorType: NonPersonRelatedPartyRelationshipType.Applicant,
    trustApplicantId: 'applicant-10',
    applicantId: 'applicant-1',
    trustApplicantClientId: 'applicant-10',
    applicantClientId: 'applicant-1',
  },
];

export const getMockRelatedParties = (): RelatedParty[] => cloneDeep(RELATED_PARTY_MOCK_DATA);
